export const ACCOUNT_INFO = "ACCOUNT_INFO";
export const SETTING_DATA = "SETTING_DATA";
export const SET_PROFILE_DATA= "SET_PROFILE_DATA"
export const LOGO_UPDATE = "LOGO_UPDATE";

